module.exports = __webpack_public_path__ + "static/media/14.086c92da.JPG";